// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f05c6576","239":"233c92b8","455":"48365038"}[chunkId] + ".chunk.js";
};